import { useAppSelector } from "redux/hooks";
import { useFetch } from "hooks/api";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPContextualCategories = (parentNodeIdFilter = null) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const params = {
    marketplace: marketPlace,
    categoryName: `inc_${parentNodeIdFilter},`,
    dsp_seller_info_id: dspAdvertiser?.id,
  };

  const { data, isLoading } = useFetch(
    ["dspContextualCategories", parentNodeIdFilter, dspAdvertiser?.id],
    "/dsp/contextual_product_categories",
    params,
    {
      select: (res) => {
        return (
          res.data?.targetOptions?.map((category) => ({
            id: category.metadata.browseNodeId,
            name: category.metadata.categoryName,
            ...category.metadata,
            path: category.categoryPath,
          })) ?? []
        );
      },
      enabled: !!parentNodeIdFilter,
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
